import { render, staticRenderFns } from "./region-government.vue?vue&type=template&id=9fc16b8e&scoped=true&"
import script from "./region-government.vue?vue&type=script&lang=js&"
export * from "./region-government.vue?vue&type=script&lang=js&"
import style0 from "./region-government.vue?vue&type=style&index=0&id=9fc16b8e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc16b8e",
  null
  
)

export default component.exports